import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { Grandpa } from "../../actors/characters/grandpa";

import { goToScene } from "../../main";
import Katie from "../../actors/characters/katie";
import MccartysCommerce from "../mccartysCommerce";
import FarmerJackson from "../../actors/characters/farmerJackson";
import Ronald from "../../actors/characters/ronald";
import { playerState } from "../../state/stateManager";
import OldMan from "../../actors/characters/oldMan";
import Cowboy from "../../actors/characters/cowboy";

export default class McCartys extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 5;
    let notice = new ex.Actor({
      pos: new ex.Vector(20 * 16, 7 * 16),
      height: 24,
      width: 100,
      color: ex.Color.fromHex("#80530f"),
    });
    this.katie = new Katie({ x: 22 * 16, y: 14 * 16 });
    this.katie.z = 4;
  }
  onInitialize(engine) {
    engine.add("mccartysCommerce", MccartysCommerce);
    Resources.McCartysMap.addToScene(this);
    console.log("mccartys: adding player: ", this.player);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.katie);

    this.player.wearingVeil = false;
    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    // const map_bounds = ex.BoundingBox.fromDimension(
    //   Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
    //   Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
    //   ex.Vector.Zero,
    //   Resources.TownMap.pos
    // );
    // this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(18 * 16, 21 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 37 * 16, y: 21 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "katie") {
        this.katie.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onDeactivate() {
    if (this.ronald !== undefined) {
      this.ronald.kill();
    }
    if (this.oldMan !== undefined) {
      this.oldMan.kill();
    }
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    // if (content.npcLocations.oldMan.location == 1) {
    if (this.oldMan == null || this.oldMan == undefined) {
      this.oldMan = new OldMan({ x: 34 * 16 + 8, y: 9 * 16 + 15 }, "mccartys");
      this.oldMan.z = 4;
      this.add(this.oldMan);
    }
    // }
    if (content.npcLocations.ronald.location == 1) {
      if (this.ronald == null || this.ronald == undefined) {
        this.ronald = new Ronald(
          { x: 34 * 16 + 8, y: 6 * 16 + 13 },
          "mccartys"
        );
        this.add(this.ronald);
        this.ronald.graphics.use("sitAtBooth");
      }
    }
    if (content.npcLocations.cowboy.location == 1) {
      if (this.cowboy == null || this.cowboy == undefined) {
        this.cowboy = new Cowboy(
          { x: 34 * 16 + 8, y: 3 * 16 + 13 },
          "mccartys"
        );
        this.add(this.cowboy);
        this.cowboy.z = 4;
      }
    }
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
  }
}
